<template>
	<div>
		<el-form ref="form" :model="form" label-width="560px">
			<el-form-item label="是否开启奖励活动">
				<el-radio-group v-model="is_reward">
					<el-radio :label="1">是</el-radio>
					<el-radio :label="0">否</el-radio>
				</el-radio-group>
			</el-form-item>
			<div v-if="is_reward == 1">
				<el-form-item label="赠送积分">
					<el-input v-model="form.point"></el-input>
				</el-form-item>
				<el-form-item label="赠送优惠券">
					<div style="display: flex; flex-wrap: wrap">
						<el-tag
							style="margin-bottom: 5px; margin-right: 5px"
							v-for="(item, i) in couponLists"
							:key="i"
              closable
              @close="handleClose(item,i)"
						>
							{{ item.name }} 【{{item.choseNum}}】
						</el-tag>
						<el-button
							type="primary"
							@click="showDouyin_coupon = true"
							style="height: 35px"
							>选择</el-button
						>
					</div>
				</el-form-item>
				<el-form-item label="赠送金额">
					<el-input v-model="form.money"></el-input>
				</el-form-item>
			</div>
		</el-form>
		<el-dialog
			:visible.sync="showDouyin_coupon"
			@close="showDouyin_coupon = false"
			width="800px"
		>
			<selectCommodity
				@close="showDouyin_coupon = false"
				@getCommod="getCommod"
				:sList="couponLists"
				:jude="2"
        :judes="4"
			></selectCommodity>
		</el-dialog>
	</div>
</template>
<script>
import selectCommodity from "@/components/commodity/newSelectCommodityNum.vue";

export default {
	components: {
		selectCommodity,
	},
	data() {
		return {
			is_reward: 0,
			showDouyin_coupon: false,
			couponLists: [],
			form: {
				point: "",
				coupon: [],
				money: "",
			},
		};
	},
	methods: {
		//选择
		getCommod(data) {
			try {
				console.log("子组件传递数据", data);
        this.couponLists = data;
        let arr = []
        this.couponLists.forEach((item)=>{
          for (var i=1;i<=item.choseNum;i++){
            arr.push(item.id)
          }
        })
				this.form.coupon = arr.join(',');
				console.log('arrrr',this.form.coupon);
				this.showDouyin_coupon = false;
			} catch (e) {
				console.log(e);
			}
    },
		//删除优惠券
		handleClose(tag,i) {
      this.form.coupon = this.form.coupon.split(',')
      this.form.coupon = this.form.coupon.filter(function(item) {
        return item != tag.id
      });
			this.couponLists.splice(i, 1);
      this.form.coupon == this.form.coupon.join(',')
      console.log('33333',this.form.coupon)
			console.log(this.couponLists);
		},
	},
};
</script>
<style lang="scss" scoped>
.el-input {
	width: 350px !important;
}
</style>
